import $ from '../vendor/jquery';

$('.hero').each(function () {
  var hero = $(this);
  var nav = $('.page-header-full');

  function setMinHeight() {
    // set the minimum height of the hero section to viewport minus the navigation
    var viewportWidth = $(window).width();
    var viewportHeight = $(window).height();

    if (viewportWidth < 1024) {
      hero.css('minHeight', 'auto');
      return;
    }

    hero.css('minHeight', viewportHeight - nav.outerHeight());
  }

  setMinHeight();

  function parallax(){
    var scrolled = $(window).scrollTop();

    if ($(window).width() < 1024) {
      hero.find('.hero-wrapper').css('transform', 'translateY(0)');
      hero.find('.container').css('opacity', 1);
      return;
    }

    hero.find('.hero-wrapper').css('transform', 'translateY(' + (scrolled * -0.5) + 'px)');
    hero.find('.container').css('opacity', 1 -(scrolled * .0005));
  };

  $(window).resize(setMinHeight);
  $(window).scroll(function(e){
    parallax();
  });

});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/hero.js